/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import MenuRightView from "../menu-right/menu-right.view";
import * as statementAction from "../../../redux/store/statement/statement.store";
import "./planning-announcement-detail.scss";
import UrlCollect from "../../../common/url-collect";
import { APIUrlDefault } from "../../../utils/configuration";
import { useSelector } from "react-redux";

export default function PlanningAnnouncementDetailDesktopView(props) {
  const [statementModel, setStatementModel] = useState();
  const is_called_from_mobile = useSelector((state) => state.embeddedStatus.isEmbedded);

  useEffect(() => {
    if (props && props.match && props.match.params && props.match.params.id) {
      statementAction
        .GetDetailStatement(props.match.params.id)
        .then((res) => res && res.content && setStatementModel(res.content))
        .catch((err) => {});
    }
  }, []);

  return (
    <div className="container">
      <div className="planning-announcement-detail mt-4 mb-4">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-8">
            {statementModel && (
              <div className="planning-announcement-content border p-3">
                <h5 className="title">{statementModel.title}</h5>
                <p
                  className="content-html"
                  dangerouslySetInnerHTML={{ __html: statementModel.content }}
                ></p>
                {statementModel.statementDocumentFile && (<>
                    <a href={APIUrlDefault + statementModel.statementDocumentFile}
                      target={is_called_from_mobile ? "" : '_blank'}
                      style={{ color: 'blue' }}>
                      Xem quyết định phê duyệt tại đây ./.
                    </a>
                    <br/>
                  </>
                )}
                {statementModel.planningId && (
                  <a href={`${!is_called_from_mobile ? UrlCollect.PlanningMapViewDetail : UrlCollect.PlanningMapViewDetailMobile}` + statementModel.planningId}
                    target={is_called_from_mobile ? "" : '_blank'}
                    style={{ color: 'blue' }}>
                    Xem bản đồ đồ án tại đây ./.
                  </a>
                )}
              </div>
            )}
          </div>
          <MenuRightView is_called_from_mobile={is_called_from_mobile}/>
        </div>
      </div>
    </div>
  );
}
